<style>

.bg{
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: url("/i/signup-bg-wizard.jpg");
  background-size: cover;
  color: black;
  padding: 20px;
  overflow-y: scroll;
}

.margin{
  margin-top: 50px;
}


</style>

<div class="bg">
  <div class="title-signup">Verify your phone</div>
  <div class="margin"><TextMessageCode textCode="{textCode}"></TextMessageCode></div>
  <div class="margin small">You should have received a text message code.  Please enter it here.</div>
  
  <div class="has-buttons"></div>
  
</div>

<div class="next">
  <button on:click="{next}">Next</button>
</div>

<script>

import {push, pop, replace, location, link} from 'svelte-spa-router';

import TextMessageCode from "../../../../components/TextMessageCode.svelte";

let textCode = "251908";

function next() {
  push("/signup/profile/personal/username");
}


</script>